// extracted by mini-css-extract-plugin
export default {"wrapper":"Notifications_wrapper__obtHO","tableTitle":"Notifications_tableTitle__CuWPb","headerWrapper":"Notifications_headerWrapper__LrTzT","readAll":"Notifications_readAll__lHY7l"};